module.exports = __webpack_public_path__ + "static/media/5-Clubs.34aefabe.svg";